export enum ListaProveedorEnum {
  ListaNegra = 1,
  ListaBlanca = 2,
  Desconocido = 3,
}
export interface EstadoProveedorOption {
  id: number;
  descripcion: string;
}

export interface MarcaListaProveedorRequest {
  proveedorIds: string[];
  TipoProveedor: ListaProveedorEnum; // se enviará como 1, 2 o 3
}